export default {
  subtitle: 'Keys authenticate requests to the Partner API. Send them in the x-api-key header.',
  never_used: 'Never used',
  revoke_confirm: 'Revoke this key? Requests using it will stop working immediately.',
  columns: {
    name: 'Name',
    key: 'Key',
    status: 'Status',
    last_used_at: 'Last used',
    created_at: 'Created',
  },
  statuses: {
    active: 'Active',
    revoked: 'Revoked',
  },
  buttons: {
    create: 'Create key',
    revoke: 'Revoke',
  },
  toasts: {
    load_error: 'Could not load the API keys.',
    error: 'Something went wrong. Please try again.',
    revoked: 'API key revoked.',
  },
};
